import React from 'react';
import { useEditorToolbar } from '@atlaskit/editor-common/toolbar';
import { PrimaryToolbar as PrimaryToolbarBase } from '@atlaskit/editor-toolbar';
export var PrimaryToolbar = function PrimaryToolbar(_ref) {
  var children = _ref.children;
  var _useEditorToolbar = useEditorToolbar(),
    editorAppearance = _useEditorToolbar.editorAppearance;
  return /*#__PURE__*/React.createElement(PrimaryToolbarBase, {
    label: "Primary Toolbar",
    reducedBreakpoints: editorAppearance !== 'full-page'
  }, children);
};